module.exports = __webpack_public_path__ + "img/pzlx4@3x.61155215.png";